import { ILayoutsCasinoSections, ISiteConfigLayouts } from "@finbackoffice/fe-core";
import { useMemo } from "react";
import { useSiteConfig } from "./useSiteConfig";

export const useLayoutCasinoConfig = (section: keyof ILayoutsCasinoSections) => {
    const siteLayoutsConfig = useSiteConfig<ISiteConfigLayouts>("layouts");

    const sectionConfig = useMemo(() => {
        return siteLayoutsConfig._casino.sections[section];
    }, [section, siteLayoutsConfig._casino.sections]);

    const casinoFiltersConfig = useMemo(
        () => sectionConfig.filters?.filter((config) => config.enable),
        [sectionConfig.filters],
    );

    const casinoWidgetsConfig = useMemo(
        () => sectionConfig.widgets?.filter((config) => config.enable),
        [sectionConfig.widgets],
    );

    const casinoGamePageConfig = useMemo(() => sectionConfig.gamePage, [sectionConfig.gamePage]);

    return {
        casinoFiltersConfig,
        casinoWidgetsConfig,
        showWinners: sectionConfig.showWinners || false,
        casinoGamePageConfig,
    };
};
